/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_File_Name_ReservedInputs */



/**
* | output |
* | --- |
* | "This name is reserved and cannot be used" |
*
* @param {Spaces_File_Name_ReservedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_file_name_reserved = /** @type {((inputs?: Spaces_File_Name_ReservedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_File_Name_ReservedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Name ist reserviert und kann nicht verwendet werden")
	return /** @type {LocalizedString} */ ("This name is reserved and cannot be used")
});